// extracted by mini-css-extract-plugin
export default {"zoomModal":"O2-z","image":"P2-z","button":"Q2-z","isOverlayShown":"R2-z"};